<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  @if (safetyFactorResultsStore) {
  <p-toolbar positionUnset="true">
    <ng-template #start>
      <div class="flex items-center gap-2 toolbar-menu">
        <p-selectButton [options]="modes" [(ngModel)]="selectedMode"
          (onChange)="onModeChange($event)" [allowEmpty]="false">
        </p-selectButton>

        @if (selectedMode !== 'minimum') {
          <p-selectButton [options]="resultsDisplay"
            [(ngModel)]="selectedResultDisplay"
            (onChange)="onSelectedResultsDisplayChange($event)" [allowEmpty]="false">
          </p-selectButton>
        }

        @if (selectedResultDisplay === 'grid' && selectedMode == 'minimum') {
          <div>
            <p-checkbox size="small" inputId="details"
              [(ngModel)]="includeCharacters"
              (onChange)="toggleCharacterView($event)" binary="true">
            </p-checkbox>
            <label class="pl-1" for="details">Show Details</label>
          </div>
        }

        @if (selectedResultDisplay === 'plot' && selectedMode !== 'minimum') {
          <p-selectButton
            [options]="depthView" [(ngModel)]="selectedDepthView"
            (onChange)="depthViewToggle($event)" [allowEmpty]="false">
          </p-selectButton>
        }

        <app-single-load-results [loadCases]="loadCases" (loadCaseSelected)="setLoadCase($event)"
          [stateStore]="safetyFactorResultsStore" [signalRChange]="signalRChange">
        </app-single-load-results>
      </div>
    </ng-template>
  </p-toolbar>
  }

  @if (selectedResultDisplay === 'plot') {
    <app-single-load-plot
      [yAxisTitle]="yAxisTitle" [xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
      [selectedDepthView]="selectedDepthView" [depthUnit]="depthUnit"
      [plotName]="plotName" [plotTitle]="'Safety Factor Results'"
      [singleLoadPlotStore]="safetyFactorResultsStore">
    </app-single-load-plot>
  }

  @if (selectedResultDisplay === 'grid') {
    <app-single-load-grid
      [apiCollapseType]="apiCollapseType"
      [selectedLoad]="safetyFactorResultsStore.state?.selectedLoadCase" [rowData]="results"
      [columnDefinitions]="columnDefinitions" tableName="Safety Factor Results" gridName="Safety Factor Results"
      [mode]="selectedMode">
    </app-single-load-grid>
  }
  
  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br />
    <br />
  </p-dialog>

  @if (safetyFactorResults != null) {
    <app-perivis-validation [errors]="safetyFactorResults[0]?.errors" />
  }
</app-tool-loader>